import { cleanCustomFontName } from 'utils';
import { AVAILABLE_FONTS } from './Config';

interface IFont {
  label: string;
  family: string;
  weight: number;
}

const isFontEqualTo = (font: IFont, otherFont: IFont): boolean => {
  return font.family === otherFont.family && font.weight === otherFont.weight;
};

const getFontFromTextStyle = (style: PIXI.TextStyle): IFont => {
  let familyId = style.fontFamily as string;
  if (style.fontStyle !== 'normal') {
    familyId += ':' + style.fontStyle;
  }
  const weight = parseInt(style.fontWeight, 10);
  for (const f of AVAILABLE_FONTS) {
    if (f.family === familyId && f.weight === weight) {
      return f;
    }
  }
  return {
    label: cleanCustomFontName(familyId),
    family: familyId,
    weight: parseInt(style.fontWeight, 10)
  };
};

const getLabelsUniqueCharacters = (fonts: IFont[]): string => {
  let characters = '';
  const addCharactersFromLabel = (label: string) => {
    let chars = characters.split('');
    const charsToAdd = label.split('');
    for (const c of charsToAdd) {
      if (!chars.includes(c)) {
        characters += c;
        chars = characters.split('');
      }
    }
  };
  for (const f of fonts) {
    addCharactersFromLabel(f.label);
  }
  return characters;
};

const WEIGHTS: string[] = [];
WEIGHTS[100] = 'Thin';
WEIGHTS[300] = 'Light';
WEIGHTS[400] = 'Regular';
WEIGHTS[500] = 'Medium';
WEIGHTS[600] = 'SemiBold';
WEIGHTS[700] = 'Bold';
WEIGHTS[800] = 'ExtraBold';
WEIGHTS[900] = 'Black';

const getWeightString = (weight: number): string => {
  return WEIGHTS[weight] || '';
};

const SYSTEM_FONTS = ['Georgia'];
const isSystemFont = (font: IFont): boolean => {
  return SYSTEM_FONTS.includes(font.family);
};

export {
  IFont,
  isFontEqualTo,
  getFontFromTextStyle,
  getLabelsUniqueCharacters,
  getWeightString,
  isSystemFont
};



// WEBPACK FOOTER //
// ./src/data/IFont.ts